import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { HStack, Switch as NBSwitch } from 'native-base';
import { Text } from '../atoms';
export function Switch({ isChecked, onToggle, label, disabled, testIDLabel, testIDSwitch, ...rest }) {
    const onTrackColor = 'interactive.text.active';
    const onThumbColor = 'noChange.white';
    const offTrackColor = 'neutral.30';
    const offThumbColor = 'noChange.white';
    return (React.createElement(HStack, { alignItems: "center", accessible: true, accessibilityState: {
            checked: isChecked,
            disabled: disabled,
        }, onAccessibilityTap: onToggle, accessibilityLabel: label, accessibilityRole: "switch", ...rest },
        label && (React.createElement(Text, { mr: 2, fontToken: "bodyBaseDefault", color: "text.20", testID: testIDLabel }, label)),
        React.createElement(NBSwitch, { onTrackColor: onTrackColor, offTrackColor: offTrackColor, isChecked: isChecked, disabled: disabled, onToggle: onToggle, onThumbColor: onThumbColor, offThumbColor: offThumbColor, testID: testIDSwitch, accessible: false, h: 7 })));
}
